import React from 'react';
import { useAuth } from '../context/AuthContext';
import FullKitting from '../components/FullKitting';

// Standalone Full Kitting page — gives the Production Incharge (who isn't in the
// Order Execution module) a focused screen to confirm kitting. Same component as
// the Order Execution → Full Kitting tab.
export default function FullKittingPage() {
  const { user } = useAuth();
  return (
    <div style={{ minHeight: '100vh', background: 'transparent' }}>
      <div style={{ padding: 24 }}>
        <h2 style={{ margin: '0 0 16px', color: '#2D2C72', fontSize: 22 }}>📦 Full Kitting</h2>
        <FullKitting user={user} />
      </div>
    </div>
  );
}
